(function () {
  angular
    .module('kareo.ui.shared.directives.k-edit-patient', [
      'angucomplete-alt',
      'kareo.ui.shared.directives.validation.input-group',
      'kareo.ui.shared.directives.k-edit-patient.private.billing-profile-types',
      'kareo.ui.shared.directives.k-edit-patient.private.k-edit-billing-profile',
      'kareo.ui.shared.directives.k-edit-patient.private.k-escape-html',
      'kareo.ui.shared.directives.k-edit-patient.private.k-highlight-matched-text',
      'kareo.ui.shared.directives.validation.prevent-form-submit',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.ui-mask',
      'kareo.ui.shared.modules.featureSet',
      'kareo.ui.shared.modules.api.patient-service',
      'kareo.ui.shared.directives.k-patient-alert',
      'kareo.ui.shared.directives.validation.k-valid-email',
      'kareo.ui.shared.directives.validation.k-valid-zip',
      'kareo.ui.shared.directives.validation.k-valid-dateofbirth',
      'kareo.ui.shared.modules.api.practice.k-practice-service'
    ])
    .directive('kEditPatient', kEditPatient);

  function kEditPatient() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        editPatientGuid: '=?patientGuid',
        onCancel: '&',
        onSuccess: '&'
      },
      template: require('./k-edit-patient.pug')()
    };
  }

  var BILLING_PROFILES_FEATURE = 'dark-feature.patient-creation-billing-profile';
  var PATIENT_DOB_FORMAT = 'MMDDYYYY';
  var NEW_PATIENT_TEMPLATE = {
    address: {}
  };

  controller.$inject = ['$q', 'BILLING_PROFILE_TYPES', 'featureSet',
    'patientService', 'kPracticeService'];

  function controller($q, BILLING_PROFILE_TYPES, featureSet,
      patientService, kPracticeService) {
    var vm = this;

    init();
    vm.cancel = cancel;
    vm.cancelDuplicatePatient = cancelDuplicatePatient;
    vm.checkDuplicates = _checkDuplicates();
    vm.confirmDuplicatePatient = confirmDuplicatePatient;
    vm.editBillingProfile = editBillingProfile;
    vm.isSelfPayInsurance = isSelfPayInsurance;
    vm.formatDate = formatDate;
    vm.formatPhoneNumber = formatPhoneNumber;
    vm.save = save;
    vm.selectDuplicatePatient = selectDuplicatePatient;
    vm.showLessPhoneNumbers = showLessPhoneNumbers;
    vm.showMorePhoneNumbers = showMorePhoneNumbers;
    vm.isValidPhoneNumber = isValidPhoneNumber;

    // -----------------------------------------------------------------------

    function init() {
      var patientPromise, requiredDataPromises;

      vm.areMorePhoneNumbersVisible = false;
      vm.duplicatePatients = [];
      vm.isBillingProfileVisible = false;
      vm.isEditingBillingProfile = false;
      vm.isSelfPayPractice = false;
      vm.isEditMode = !!vm.editPatientGuid;
      vm.isLoading = true;
      vm.activeIntake = null;

      if (vm.isEditMode) {
        patientPromise = patientService
          .getPatientWithPreferredAddress(vm.editPatientGuid)
          .catch(() => {
            vm.isEditMode = false;
            return makeNewPatientPromise();
          });
        patientService.getActivePatientIntakeByPatientGuid(vm.editPatientGuid)
          .then((intake) => {
            vm.activeIntake = intake;
          });
      } else {
        patientPromise = makeNewPatientPromise();
      }

      requiredDataPromises = {
        genders: patientService.getGenders(),
        states: patientService.getStates(),
        patient: patientPromise,
        features: featureSet.load(),
        selfPay: kPracticeService.getPracticeSelfPay()
      };

      $q.all(requiredDataPromises)
        .then((results) => {
          var dobMoment, i, patient;

          patient = results.patient;

          if (!!patient.dateOfBirth) {
            dobMoment = moment(patient.dateOfBirth).utc();
            patient.dateOfBirth = dobMoment.format(PATIENT_DOB_FORMAT);
          }

          if (!!patient.address.stateId) {
            for (i = 0; i < results.states.length; i++) {
              if (results.states[i].stateId === patient.address.stateId) {
                patient.address.state = results.states[i];
                break;
              }
            }
          }
          setFeatures(results.features);
          vm.genders = setGenders(results.genders);
          vm.states = results.states;
          vm.patient = patient;
          vm.isLoading = false;
          vm.isSelfPayPractice = !!results.selfPay.value && results.selfPay.value=='true';
        }, () => {
          vm.wasUnableToLoad = true;
        });
    }

    // -----------------------------------------------------------------------

    function setGenders(genders) {
      const genArr = genders.map(gender => {
        let {
          name,
          genderId,
          abbreviation
        } = gender;
        if (name.toLowerCase() === 'undifferentiated' && vm.isClinicalCodeFeatureEnabled) {
          name = 'Unknown';
        }
        return {
          genderId,
          name,
          abbreviation
        };
      });
      return genArr;
    }

    function setFeatures(features) {
      vm.isBillingProfileVisible = !!features[BILLING_PROFILES_FEATURE];
      vm.isClinicalCodeFeatureEnabled = !!features['dark-feature.clinical-code-set.updates'];
    }

    function cancel(isDirty) {
      vm.onCancel({ isDirty });
    }

    function cancelDuplicatePatient() {
      vm.selectedDuplicatePatient = null;
    }

    function _checkDuplicates() {
      var pendingRequestCanceller, lastUpdate = {};

      return function checkDuplicates() {
        var patient;

        // This should only fire when creating a new patient
        if (vm.isEditMode) {
          return;
        }

        if (!!pendingRequestCanceller) {
          pendingRequestCanceller.resolve();
        }

        patient = vm.patient;

        if (patient.firstName === lastUpdate.firstName &&
          patient.lastName === lastUpdate.lastName &&
          patient.dateOfBirth === lastUpdate.dateOfBirth) {
          return;
        }

        // Must have either first & last name, or DOB, to search
        if ((!patient.firstName || !patient.lastName) && !patient.dateOfBirth) {
          return;
        }

        lastUpdate.firstName = patient.firstName;
        lastUpdate.lastName = patient.lastName;
        lastUpdate.dateOfBirth = patient.dateOfBirth;

        pendingRequestCanceller = $q.defer();
        vm.duplicatePatients = [];

        patientService
          .checkDuplicatePatients(patient, pendingRequestCanceller.promise)
          .then((duplicates) => {
            vm.duplicatePatients = duplicates || [];
            pendingRequestCanceller = null;
          }, () => {
            pendingRequestCanceller = null;
          });
      };
    }

    function confirmDuplicatePatient() {
      succeedWithPatient(vm.selectedDuplicatePatient);
    }

    function editBillingProfile() {
      vm.isEditingBillingProfile = true;
    }

    function formatDate(date) {
      return moment(date, PATIENT_DOB_FORMAT).format('MM/DD/YYYY');
    }

    function formatPhoneNumber(phoneNumber) {
      var phoneStr = '' + phoneNumber;
      if (phoneStr.length !== 10) {
        return phoneStr;
      }

      return '(' + phoneStr.substr(0, 3) + ')' + phoneStr.substr(3, 3) + '-' +
        phoneStr.substr(6, 4);
    }

    function isSelfPayInsurance() {
      return vm.patient.insurance === BILLING_PROFILE_TYPES.SELF_PAY;
    }

    function makeNewPatientPromise() {
      return $q.when(angular.copy(NEW_PATIENT_TEMPLATE));
    }

    function save() {
      var savePromise;

      if (vm.isSaving || vm.isRedirecting) {
        return;
      }

      vm.isSaving = true;

      if (vm.isSelfPayPractice){
        vm.patient.insurance = BILLING_PROFILE_TYPES.SELF_PAY;
      }

      savePromise = vm.isEditMode ?
          updatePatient(vm.patient) :
          createPatient(vm.patient);

      savePromise
        .then((savedPatient) => {
          vm.didSaveErrorOccur = false;
          vm.isRedirecting = true;
          succeedWithPatient(savedPatient);
          vm.isSaving = false;
        }, () => {
          vm.isSaving = false;
          vm.didSaveErrorOccur = true;
        });
    }

    function createPatient(patient) {
      sanitizePatient(patient);
      return patientService.createPatient(patient);
    }

    function updatePatient(patient) {
      sanitizePatient(patient);
      return patientService.updatePatient(patient);
    }

    function sanitizeString(value){
      value = value.replaceAll('&lt;','');
      value = value.replaceAll('&gt;','');
      return value;
    }

    function sanitizePatient(patient){
      if (patient?.firstName){
        patient.firstName = sanitizeString(patient.firstName);
      }
      if (patient?.middleName){
        patient.middleName = sanitizeString(patient.middleName);
      }
      if (patient?.lastName){
        patient.lastName = sanitizeString(patient.lastName);
      }
      if (patient?.address){
        if (patient.address?.address1){
          patient.address.address1 = sanitizeString(patient.address.address1);
        }
        if (patient.address?.address2){
          patient.address.address2 = sanitizeString(patient.address.address2);
        }
        if (patient.address?.city){
          patient.address.city = sanitizeString(patient.address.city);
        }
      }
    }

    function selectDuplicatePatient(patient) {
      vm.selectedDuplicatePatient = patient;
    }

    function showMorePhoneNumbers() {
      vm.areMorePhoneNumbersVisible = true;
    }

    function showLessPhoneNumbers() {
      vm.areMorePhoneNumbersVisible = false;
    }

    function isValidPhoneNumber() {
      return vm.patient ? (vm.patient.mobilePhone || vm.patient.homePhone || vm.patient.workPhone) : false;
    }

    function succeedWithPatient(patient) {
      vm.isRedirecting = true;
      vm.onSuccess({ patient });
    }
  }
})();
